import React from 'react';
import { moneyDecimalFormatter, customRound } from 'utli';
import Table from 'components/Table';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { t } from 'i18next';
import PrintTransaction from './printTransaction';

function List({
  headers,
  data,
  buttons,
  filter,
  onPageChange,
  onInvoiceClick,
}) {
  return (
    <div className='address-table'>
      <Table
        data={data}
        title={t('Custom Duty Invoice')}
        subtitle={t('sidebar.transaction')}
        filter={filter}
        onPageChange={onPageChange}
        headers={headers.map((e) => (
          <th
            className={clsx('headers', e.className)}
            key={`thead-${Math.random()}`}
            style={{ width: e.width, left: e.left }}
          >
            {t(e.text)}
          </th>
        ))}
        buttons={buttons}
        rows={data?.docs?.map((e, index) => (
          <tr key={`table-row-${index}-${Math.random()}`}>
            <td className='fixed-cell left'>
              <span style={{ cursor: 'pointer' }} onClick={() => onInvoiceClick(e)}>
                {e.invoice_number}
              </span>
            </td>

            <td>{e.transaction_invoice?.address_code}</td>
            <td>{dayjs(e?.purchase_date).format('DD/MM/YYYY')}</td>
            <td>{dayjs(e?.transaction_invoice?.invoice_date).format('DD/MM/YYYY')}</td>
            <td>{e.name}</td>
            <td>{e.phonenumber}</td>
            <td>{e.collectionType?.name}</td>
            <td>{e.currency}</td>
            <td>{e.exchangeRate}</td>
            <td>{moneyDecimalFormatter(customRound(e.paid_amount))}</td>
            <td>{moneyDecimalFormatter(customRound(e.billing_amount))}</td>
            <td>{moneyDecimalFormatter(customRound(e.discount))}</td>
            <td>{moneyDecimalFormatter(customRound(e.remaining_balance))}</td>
            <td>{e.reference_number}</td>
            <td>{e.createdBy?.name}</td>
            <td>{e.remark}</td>
            <td className='fixed-cell px-2'>
              <PrintTransaction selectedData={e} />
            </td>
          </tr>
        ))}
      />
    </div>
  );
}

export default List;
